var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { isNumber } from "lodash";
import { injectIntl, getResolvedMessage } from "@irati/utils/lang";
import onEnter from "@irati/utils/onEnter";
import { TagElement } from "./styled";
var Tag = /** @class */ (function (_super) {
    __extends(Tag, _super);
    function Tag() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tag.prototype.render = function () {
        var _a = this.props, className = _a.className, name = _a.name, count = _a.count, selected = _a.selected, tag = _a.tag, onClick = _a.onClick;
        return (React.createElement(TagElement, { className: className, selected: selected, tag: tag, tabIndex: 0, role: "button", onClick: onClick, onKeyPress: function (e) { return onEnter(e, onClick); }, "data-test-name": name, "data-test-selected": selected ? "true" : "false" },
            getResolvedMessage(this, "name"),
            isNumber(count) && React.createElement("span", null,
                " (",
                count,
                ")"),
            selected && tag && React.createElement("span", { style: { fontWeight: "normal", paddingLeft: "5px" } }, "\u00D7")));
    };
    Tag.defaultProps = {
        onClick: function () { }
    };
    return Tag;
}(PureComponent));
export { Tag };
export default injectIntl(Tag, { withRef: true });
